import {Store} from "@tanstack/react-store";

export interface IntentPayload {
  namespace: string;
  action: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
}

export interface IntentState {
  intent: IntentPayload | null;
}

/**
 * TanStack Store instance for contextual tool call intents.
 * Created at module level — stable instance across renders.
 */
export const intentStore = new Store<IntentState>({
  intent: null,
});
